import script from "./allWorkouts.vue?vue&type=script&setup=true&lang=js"
export * from "./allWorkouts.vue?vue&type=script&setup=true&lang=js"

import "./allWorkouts.vue?vue&type=style&index=0&id=7270da3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7270da3f"]])

export default __exports__